import { Box, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"

import {
  ContentContainer,
  SourceDescription,
  CenterContainer,
  RecipientContainer,
  ButtonTransfer, 
  CloseButton,
} from "./styled"
import IconBox from "../../components/IconBox"
import UIIcon from "../../components/UIIcon"

const AuthErrorPage = () => {
  const navigate = useNavigate()
  const handleClickBack = () => {
    navigate("/quit")
  }

  return (
    <ContentContainer>
      <CenterContainer>
        <IconBox size="lg">
          <UIIcon iconName="globalErrorIcon" size={80} />
        </IconBox>
        <SourceDescription variant="h3">Слишком много попыток</SourceDescription>
        <RecipientContainer>
          <Typography variant="h4">Пожалуйста, попробуйте снова позже</Typography>
        </RecipientContainer>
      </CenterContainer>
      <Box sx={ButtonTransfer}>
        <CloseButton color="secondary" variant="contained" fullWidth onClick={handleClickBack}>
          Закрыть
        </CloseButton>
      </Box>
    </ContentContainer>
  )
}

export default AuthErrorPage
